import React from 'react';
import { FormattedMessage } from 'react-intl';

const SettingLine = ({
  headingMessageId,
  subHeadingMessageId,
  wrapperClassName,
  headingClassName,
  subHeadingClassName,
  component,
  headingDivClassName,
}) => {
  return (
    <div
      className={
        wrapperClassName ||
        'd-flex align-content-center justify-content-between'
      }
    >
      {(headingMessageId || subHeadingMessageId) && (
        <div style={{ width: '60%' }} className={`${headingDivClassName} mr-2`}>
          {headingMessageId && (
            <span className={headingClassName || 'd-block font-medium-1 dark'}>
              <FormattedMessage id={headingMessageId} />
            </span>
          )}
          {subHeadingMessageId && (
            <span className={subHeadingClassName || 'd-block font-small-2'}>
              <FormattedMessage id={subHeadingMessageId} />
            </span>
          )}
        </div>
      )}
      <div
        style={{ width: '40%', minWidth: '115px' }}
        className="d-flex align-items-center justify-content-end"
      >
        {component}
      </div>
    </div>
  );
};

export default SettingLine;
